import React, { useState } from "react";
import { publicContactService } from "../services/publicApi";

const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [sending, setSending] = useState(false);
  const [feedback, setFeedback] = useState({ type: '', text: '' });
  const contactCards = [
    {
      title: 'Telephone',
      value: '05 22 34 06 59',
      href: 'tel:0522340659',
      icon: 'fas fa-phone-volume'
    },
    {
      title: 'Email',
      value: 'info@domoelec.ma',
      href: 'mailto:info@domoelec.ma',
      icon: 'fas fa-envelope'
    },
    {
      title: 'Showroom',
      value: '47 Rue Des Orangers, Ain Sebaa - Casablanca',
      icon: 'fas fa-map-marker-alt'
    },
    {
      title: 'Bureau',
      value: '2eme etage, N 16, 80 Bd Moulay Slimane, Casablanca 20250',
      icon: 'fas fa-building'
    },
    {
      title: 'Horaires',
      value: 'Lundi à Vendredi : 8h30 – 18h00',
      icon: 'fas fa-clock'
    }
  ];

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) return;
    if (form.message.trim().length < 10) {
      setFeedback({
        type: 'error',
        text: 'Le message doit contenir au moins 10 caracteres.'
      });
      return;
    }

    setFeedback({ type: '', text: '' });
    setSending(true);

    try {
      const response = await publicContactService.sendMessage(form);
      setForm({ name: '', email: '', phone: '', subject: '', message: '' });
      setFeedback({
        type: 'success',
        text: response?.message || 'Votre message a bien ete envoye.'
      });
    } catch (error) {
      setFeedback({
        type: 'error',
        text:
          error?.response?.data?.message ||
          "Impossible d'envoyer votre message pour le moment."
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="ct-page">
      {/* Header */}
      <section className="ct-header">
        <div className="container">
          <span className="ct-label">Parlons de votre projet</span>
          <h1>Contactez-<span className="hdr-green">nous</span></h1>
          <p>Une question, un devis ou une demande d'information ? Nous sommes à votre écoute.</p>
        </div>
      </section>

      {/* Form first */}
      <section className="ct-main">
        <div className="container">
          <div className="ct-grid">
            <div className="ct-form-wrapper">
              <span className="ct-section-tag">Envoyer un message</span>
              <h2>Envoyez-nous un <span className="hdr-green">message</span></h2>
              <p className="ct-form-hint">
                Partagez votre besoin, votre demande de devis ou les details de votre projet. Notre equipe vous recontacte rapidement.
              </p>
              {feedback.text && (
                <div className={`ct-feedback ct-feedback--${feedback.type}`}>
                  {feedback.text}
                </div>
              )}
              <form className="ct-form" onSubmit={handleSubmit}>
                <div className="ct-form-row">
                  <div className="ct-field">
                    <label>Nom *</label>
                    <input type="text" name="name" value={form.name} onChange={handleChange} placeholder="Votre nom complet" required />
                  </div>
                  <div className="ct-field">
                    <label>Email *</label>
                    <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="votre@email.com" required />
                  </div>
                </div>
                <div className="ct-form-row">
                  <div className="ct-field">
                    <label>Téléphone</label>
                    <input type="tel" name="phone" value={form.phone} onChange={handleChange} placeholder="06 XX XX XX XX" />
                  </div>
                  <div className="ct-field">
                    <label>Sujet</label>
                    <input type="text" name="subject" value={form.subject} onChange={handleChange} placeholder="Sujet de votre message" />
                  </div>
                </div>
                <div className="ct-field">
                  <label>Message *</label>
                    <textarea name="message" value={form.message} onChange={handleChange} rows="5" minLength="10" placeholder="Décrivez votre projet ou votre demande..." required></textarea>
                </div>
                <button type="submit" className="ct-submit" disabled={sending}>
                  <i className="far fa-paper-plane"></i> {sending ? 'Envoi en cours...' : 'Envoyer le message'}
                </button>
              </form>
            </div>

            <div className="ct-visual-wrapper">
              <div className="ct-visual-card">
                <div className="ct-support-visual">
                  <div className="ct-support-ring ct-support-ring--one"></div>
                  <div className="ct-support-ring ct-support-ring--two"></div>
                  <div className="ct-support-icon">
                    <i className="fas fa-headset"></i>
                  </div>
                </div>
                <div className="ct-visual-content">
                  <span className="ct-section-tag">Assistance</span>
                  <h3>Besoin d'aide ?</h3>
                  <p>
                    Notre equipe est a votre disposition pour vous accompagner dans la reussite de vos projets.
                  </p>
                  <div className="ct-visual-points ct-visual-points--centered">
                    <div className="ct-visual-point"><i className="fas fa-check-circle"></i><span>Reponse rapide</span></div>
                    <div className="ct-visual-point"><i className="fas fa-check-circle"></i><span>Accompagnement expert</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact infos after form */}
      <section className="ct-infos">
        <div className="container">
          <div className="ct-infos-head">
            <span className="ct-section-tag">Informations de contact</span>
            <h2>Nos coordonnees</h2>
            <p>Retrouvez nos informations de contact, notre adresse et notre localisation.</p>
          </div>

          <div className="ct-infos-grid">
            {contactCards.map((item) => {
              const content = (
                <>
                  <div className="ct-info-icon"><i className={item.icon}></i></div>
                  <div className="ct-info-text">
                    <h4>{item.title}</h4>
                    <p>{item.value}</p>
                  </div>
                </>
              );

              if (item.href) {
                return (
                  <a href={item.href} className="ct-info-item" key={item.title}>
                    {content}
                  </a>
                );
              }

              return (
                <div className="ct-info-item" key={item.title}>
                  {content}
                </div>
              );
            })}
          </div>

          <div className="ct-map-block">
            <div className="ct-map-copy">
              <span className="ct-section-tag">Localisation</span>
              <h3>Venez nous rencontrer a Casablanca</h3>
              <p>
                Nous accompagnons les projets tertiaires, industriels, hoteliers et residentiels avec des solutions
                electriques et courants faibles adaptees a chaque besoin.
              </p>
            </div>
            <div className="ct-map-wrapper">
              <div className="ct-map">
                <iframe
                  title="DOMOELEC Localisation"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3323.0!2d-7.55!3d33.59!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzPCsDM1JzI0LjAiTiA3wrAzMycwMC4wIlc!5e0!3m2!1sfr!2sma!4v1!5m2!1sfr!2sma"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
